import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import _uniqueId from 'lodash/uniqueId';

import { AppContext } from '../../context/AppContext';
import { CaptchaForm } from '..';
import { TextInput, Button, LoadingSpinner, Checkbox } from '../../elements';

import styles from './ContactForm.module.scss';
import { getCaptchaData, postApplicationData } from '../../services';
import { SUCCESS } from '../../navigation/routes';
import { UPDATE_LEAD } from '../../context/ActionTypes';


const ContactForm = () => {
	const { state, dispatch } = React.useContext(AppContext);
	const {
		handleSubmit,
		formState: { errors },
		register,
	} = useForm({ criteriaMode: 'all', mode: 'onSubmit' });
	const [captcha, setCaptcha] = React.useState(null);
	const [isLoading, setLoading] = React.useState(false);
	const [dataProtection, setDataProtection] = React.useState(true);
	const navigate = useNavigate();

	const requestCaptchaData = (contactData, captchaValue) => {
		setLoading(true);

		getCaptchaData()
			.then(res => {
				if (res.token) setCaptcha(res);
			})
			.then(() =>  {
				dispatch({ type: UPDATE_LEAD, payload: contactData });
				setLoading(false)
			});
	};

	const onSubmit = (captchaValue) => {
		setLoading(true);

		postApplicationData(captcha.token, captchaValue, state)
			.then((res) => {
				console.log(res);
				navigate(SUCCESS);
			})
			.catch((err) => console.log(err))
			.then(() => setLoading(false));
	}

	return (
		<div className={styles.wrapper}>
			{isLoading && <LoadingSpinner />}

			{!isLoading && captcha && (
				<CaptchaForm
					captchaQuestion={captcha.label}
					onResolveCaptcha={(captchaValue) => onSubmit(captchaValue)}
				/>
			)}

			{!isLoading && !captcha && (
				<form onSubmit={handleSubmit((data) => requestCaptchaData(data))}>
					<TextInput
						type='text'
						label='Name'
						errors={errors}
						defaultValue={state.lead ? state.lead.lastname : ''}
						{...register('lastname', { required: true })}
					/>

					<TextInput
						type='text'
						label='Position'
						errors={errors}
						defaultValue={state.lead ? state.lead.job : ''}
						{...register('job', { required: true })}
					/>

					<TextInput
						type='text'
						label='Unternehmen'
						errors={errors}
						defaultValue={state.lead ? state.lead.company : ''}
						{...register('company', { required: true })}
					/>

					<TextInput
						type='tel'
						label='Telefonnummer'
						errors={errors}
						defaultValue={state.lead ? state.lead.tel : ''}
						{...register('tel', { required: true })}
					/>

					<TextInput
						type='email'
						label='E-Mail-Adresse'
						errors={errors}
						defaultValue={state.lead ? state.lead.email : ''}
						{...register('email', { required: true })}
					/>

					
					<Checkbox
						id={_uniqueId('checkbox_')}
						label={
							<span>Ich habe die {' '}
								<a className={styles.link} href='http://www.schindler.com/de/internet/de/system/disclaimer-navigation/datenschutzerklaerung.html' rel="noreferrer" target="_blank">
								Datenschutzerklärung</a> zur Kenntnis genommen.
							</span>}
						onChange={(e) => setDataProtection(!e.target.checked)}
					/>

					<div className={styles.formFooter}>
						<Button title='Angebot anfordern' type='submit' disabled={dataProtection} />
					</div>
				</form>
			)}
		</div>
	);
};


export default ContactForm;
